import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Actions
import {
  fetchSaveStudy,
  discardStudy,
  setStudySavePath,
  setVirtualKeyboard,
  setSaveAndQuit,
  discardStudyFile,
  fetchCheckWifi,
} from "../../actions";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import FolderIcon from "@material-ui/icons/Folder";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputBase from "@material-ui/core/InputBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import Box from "@material-ui/core/Box";
// Other Files
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";
import VirtualKeyboard from "../Shared/VirtualKeyboard";
import { wifiEnabled } from "../../constants/constants";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  buttonContainer: customTheme().dialog.buttonContainer,
  title: customTheme().dialog.title,
  contentContainer: (props) => ({
    ...customTheme().dialog.contentContainer,
    ...customTheme(props.theme).customScrollBar,
    overflowY: "auto",
  }),
  contentItemPadding: customTheme().dialog.contentItemPadding,
  buttonOutlined: (props) => ({
    width: "110px",
    ...customTheme(props.theme).buttonOutlined,
  }),
  button: (props) => ({
    width: "110px",
    ...customTheme(props.theme).buttonPrimary,
  }),
  buttonDiscard: (props) => ({
    width: "190px",
    ...customTheme(props.theme).buttonPrimary,
  }),
  buttonProgress: (props) => customTheme(props.theme).buttonProgress,
  formText: customTheme().formText,
  fileIcon: (props) => customTheme(props.theme).iconButton,
  progressIndicatorDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px",
    flexDirection: "column",
    alignItems: "center",
  },
  progressIndicatorText: {
    width: "350px",
    paddingTop: "15px",
    textAlign: "center",
  },
  progressCircle: {
    color: "rgba(255,255,255,1)",
  },
  progressLabel: {
    fontSize: "0.9rem",
  },
});

const SaveStudyDialog = (props) => {
  const classes = useStyles(props);
  const [fileName, setFileName] = React.useState(props.initialName);
  const [filePath, setFilePath] = React.useState(props.initialPath);
  const [extension, setExtension] = React.useState(props.extension);
  const [encryption, setEncryption] = React.useState(props.encryption);
  const [syncRemote, setSyncRemote] = React.useState(false);
  const [progressIndicator, setProgressIndicator] = React.useState({
    value: 0,
    message: null,
  }); // Circular progress value

  const [keyboardInput, setKeyboardInput] = React.useState({
    inputName: "fileName",
    inputUpdate: { fileName: "" },
  });

  useEffect(() => {
    props.fetchCheckWifi(false, false);
  }, []);

  useEffect(() => {
    if (
      props.wifiConnection &&
      wifiEnabled &&
      props.participantId !== "NO_ID"
    ) {
      setSyncRemote(true);
    }
  }, [props.wifiConnection]);
  // useEffect(() => {
  //   props.eventSource.addEventListener("progress_indicator", handleEvent);
  //   return () => {
  //     props.eventSource.removeEventListener("progress_indicator", handleEvent);
  //   };
  // }, []);

  const handleEvent = (e) => {
    switch (e.type) {
      case "progress_indicator":
        let data = JSON.parse(e.data);
        console.log(data);
        setProgressIndicator({
          value: data.value * 100,
          message: data.message,
        });
        break;
      default:
    }
  };

  const handleSave = (event) => {
    props.setStudySavePath(filePath + "/" + fileName + extension);

    if (filePath !== props.initialPath) {
      props.setStudySavePath(
        filePath + "/" + props.studyId + "/" + fileName + extension
      );
      props.fetchSaveStudy(
        props.prompt,
        encryption,
        syncRemote,
        props.initialPath
      );
    } else {
      props.fetchSaveStudy(props.prompt, encryption, syncRemote);
    }
    props.setVirtualKeyboard(false);
  };

  const handleCancel = (event) => {
    const pathArray = props.studySavePath.split("/");
    const oldPath = pathArray.splice(0, pathArray.length - 1).join("/");
    const oldName = pathArray.splice(-1)[0].split(".")[0];
    props.onClose();
    props.setSaveAndQuit(false);
    setFileName(oldName);
    setFilePath(oldPath);
  };

  const handleFileExplorer = () => {
    // const { dialog } = window.require("electron").remote;
    // const defaultPath = filePath.split("/").join("\\");
    // dialog.showOpenDialog(
    //   {
    //     defaultPath: defaultPath,
    //     properties: ["openDirectory"],
    //   },
    //   (filePaths) => {
    //     if (filePaths !== undefined && filePaths.length !== 0) {
    //       let newPath = filePaths[0].split("\\").join("/");
    //       setFilePath(newPath);
    //     }
    //   }
    // );
  };

  const handleTextFieldChange = () => (event) => {
    setFileName(event.target.value);
    setKeyboardInput({
      ...keyboardInput,
      inputUpdate: { fileName: event.target.value },
    });
  };

  const handleDiscard = () => {
    // props.discardStudyFile(
    //   props.studySavePath,
    //   props.studySaved,
    //   props.studyId
    // );
    props.discardStudy(props.prompt);
  };

  const handleEncryptionToggle = () => {
    if (encryption) {
      setEncryption(false);
      setExtension(".study");
    } else {
      setExtension(".study.encrypt");
      setEncryption(true);
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.resetPrompts}
      onExiting={() => props.setVirtualKeyboard(false)}
      PaperProps={{ className: classNames(classes.root) }}
      disableBackdropClick={true}
    >
      {!(props.prompt === "QUIT") && !(props.prompt === "LOGOUT") && (
        <Typography
          className={classes.title}
          variant="h4"
          color="textPrimary"
          align="center"
        >
          Save Study As
        </Typography>
      )}
      {(props.prompt === "QUIT" || props.prompt === "LOGOUT") && (
        <Typography
          className={classes.title}
          variant="h4"
          color="textPrimary"
          align="center"
        >
          Save Changes Before Quitting?
        </Typography>
      )}
      <DialogContent className={classes.contentContainer}>
        <InputBase
          className={classes.contentItemPadding}
          value={filePath}
          fullWidth
          multiline
          rowsMax={2}
          readOnly
          startAdornment={
            <InputAdornment position="start">
              <IconButton
                className={classes.fileIcon}
                onClick={handleFileExplorer}
                disabled
              >
                <FolderIcon />
              </IconButton>
            </InputAdornment>
          }
          inputProps={{
            className: classes.formText,
          }}
        />
        <FormControl className={classes.contentItemPadding} fullWidth>
          <FormControlLabel
            control={
              <Checkbox
                disabled
                checked={encryption}
                onChange={() => handleEncryptionToggle()}
                color="primary"
              />
            }
            label="Encrypt study folder"
          />
        </FormControl>
        {wifiEnabled && (
          <FormControl className={classes.contentItemPadding} fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  checked={syncRemote}
                  onChange={() => setSyncRemote(!syncRemote)}
                  color="primary"
                  disabled
                />
              }
              label="Sync study to cloud"
            />
          </FormControl>
        )}
        <FormControl
          onFocus={() => {
            props.setVirtualKeyboard(true);
          }}
          className={classes.contentItemPadding}
          fullWidth
        >
          <Input
            value={fileName}
            onChange={handleTextFieldChange()}
            endAdornment={
              <InputAdornment position="end">{extension}</InputAdornment>
            }
            inputProps={{
              className: classes.formItem,
            }}
          />
          <FormHelperText id="file-name">File Name</FormHelperText>
        </FormControl>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <Button
          disabled={props.requestSave}
          onClick={() => handleCancel()}
          className={classes.buttonOutlined}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleSave()}
          className={classes.button}
          variant="contained"
          color="primary"
        >
          {/* {props.requestSave && (
            <CircularProgress
              color="inherit"
              size={25}
              className={classes.buttonProgress}
            />
          )} */}
          Save
        </Button>

        {(props.prompt === "QUIT" || props.prompt === "LOGOUT") && (
          <Button
            onClick={() => handleDiscard()} // keep user info if only quitting
            className={classes.buttonDiscard}
            variant="contained"
            color="primary"
          >
            Discard Changes
          </Button>
        )}
      </DialogActions>
      {props.requestSave && (
        <div className={classes.progressIndicatorDiv}>
          <Box
            className={classes.progressCircle}
            position="relative"
            display="inline-flex"
          >
            <CircularProgress
              size={38}
              variant="static"
              value={progressIndicator.value}
            />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                className={classes.progressLabel}
                variant="caption"
                component="div"
              >{`${Math.round(progressIndicator.value)}%`}</Typography>
            </Box>
          </Box>

          <Typography>
            {progressIndicator.message !== null
              ? progressIndicator.message
              : "Saving study..."}
          </Typography>
        </div>
      )}
      <VirtualKeyboard
        anchor={"center"}
        keyboardInitialInput={{ fileName: fileName }}
        keyboardInputUpdate={keyboardInput.inputUpdate}
        keyboardInputName={keyboardInput.inputName}
        keyboardChange={(event) => setFileName(event)}
      />
    </Dialog>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchSaveStudy,
      discardStudy,
      setStudySavePath,
      setVirtualKeyboard,
      setSaveAndQuit,
      discardStudyFile,
      fetchCheckWifi,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    studySavePath: state.studyInfo.studySavePath,
    studySaved: state.studyInfo.studySaved,
    requestSave: state.studyInfo.requestSave,
    studyId: state.studyInfo.id,
    encryption: state.studyInfo.encryption,
    wifiConnection: state.utility.wifi.wifiConnection,
    participantId: state.studyInfo.participantId,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveStudyDialog);
